export const PARTNER_HOSTS = {
  'miamiops.havnclub.com': 'miami',
  'phoenixops.havnclub.com': 'phoenix',
  'chicagoops.havnclub.com': 'chicago',
}

export const CORE_CITIES = [
  { id: 'sd', name: 'San Diego' },
  { id: 'dc', name: 'Washington DC' },
]

export const PARTNER_CITIES = [
  { id: 'miami', name: 'Miami' },
  { id: 'phoenix', name: 'Phoenix' },
  { id: 'chicago', name: 'Chicago' },
]

export function cityFromHost(hostname) {
  const host = hostname.toLowerCase()
  // Local testing: miamiops.localhost etc. open a partner city against a local server.
  const local = host.match(/^([a-z]+)ops\.localhost$/)?.[1]
  return PARTNER_HOSTS[host] || PARTNER_CITIES.find(city => city.id === local)?.id || null
}

export function initialCity({ hostname, pathname }, storage) {
  const hostedCity = cityFromHost(hostname)
  const linkedCity = CORE_CITIES.find(city => pathname === `/${city.id}` || pathname.startsWith(`/${city.id}/`))?.id
  const city = hostedCity || linkedCity
  if (city) {
    // Start partner cities on the newest menu; manual week choices last until reload.
    const latestMenuOnOpen = Boolean(hostedCity)
    if (latestMenuOnOpen || storage.getItem('havn_current_city') !== city || linkedCity) storage.removeItem('havn_current_menu')
    storage.setItem('havn_current_city', city)
    return city
  }
  const saved = storage.getItem('havn_current_city')
  return CORE_CITIES.some(city => city.id === saved) ? saved : null
}

export function orderSourceLabel(city) {
  return PARTNER_CITIES.some(partner => partner.id === city) ? 'Havn OS' : 'Airtable'
}
